import MeetingComment, {CommentAttachment, CommentReactedUser, CommentUser} from './MeetingComment'
import {Nullable} from '../../../app/TypeHelpers'

export default class MeetingCommentView extends MeetingComment {
    replyCount: number
    latestReplyDatetime: Nullable<string>

    constructor(
        meetingCommentId: number,
        content: string,
        user: CommentUser,
        updateDatetime: string,
        commentReactedUserList: CommentReactedUser[],
        attachmentList: CommentAttachment[],
        isYou: boolean,
        version: number,
        replyCount: number,
        latestReplyDatetime: Nullable<string>,
    ) {
        super(meetingCommentId, content, user, updateDatetime, commentReactedUserList, attachmentList, isYou, version)
        this.replyCount = replyCount
        this.latestReplyDatetime = latestReplyDatetime
    }
}
